// ====================================================================================
// breadcrumbs.module
// ====================================================================================
import $ from "jquery";

const updateBreadcrumbPosition = () => {
  const $breadcrumb = $(".breadcrumb");
  if ($breadcrumb.length === 0) return;

  const container = $breadcrumb[0];
  const { scrollLeft, scrollWidth, clientWidth } = container;

  $breadcrumb.removeClass("scroll-start scroll-middle scroll-end");

  if (scrollLeft <= 0) {
    $breadcrumb.addClass("scroll-start");
  } else if (scrollLeft >= scrollWidth - clientWidth - 1) {
    $breadcrumb.addClass("scroll-end");
  } else {
    $breadcrumb.addClass("scroll-middle");
  }
};

const initDragScroll = () => {
  const $breadcrumb = $(".breadcrumb");
  if ($breadcrumb.length === 0) return;

  let isDragging = false;
  let startPosition = 0;
  let initialScrollLeft = 0;
  let hasMoved = false;
  let scrollTimeout;
  const dragThreshold = 5;

  const startDrag = (pageX, scrollLeft) => {
    isDragging = true;
    hasMoved = false;
    startPosition = pageX;
    initialScrollLeft = scrollLeft;
    $breadcrumb.addClass("dragging");
  };

  const endDrag = () => {
    isDragging = false;
    hasMoved = false;
    $breadcrumb.removeClass("dragging");
  };

  const handleMove = (pageX, multiplier = 1) => {
    if (!isDragging) return false;

    const distance = Math.abs(startPosition - pageX);

    if (distance > dragThreshold) {
      hasMoved = true;
      const scrollDistance = (startPosition - pageX) * 1.5 * multiplier;
      $breadcrumb.scrollLeft(initialScrollLeft + scrollDistance);
      updateBreadcrumbPosition();
      return true;
    }

    return false;
  };

  const isLinkElement = (target) => {
    const $target = $(target);
    return $target.is("a") || $target.closest("a").length > 0;
  };

  // Mouse events
  $breadcrumb
    .on("mousedown", (e) => {
      if (!isLinkElement(e.target)) {
        startDrag(e.pageX - $breadcrumb.offset().left, $breadcrumb.scrollLeft());
        e.preventDefault();
      }
    })
    .on("mouseleave mouseup", endDrag)
    .on("mousemove", (e) => {
      if (handleMove(e.pageX - $breadcrumb.offset().left)) {
        e.preventDefault();
      }
    });

  // Touch events
  $breadcrumb
    .on("touchstart", (e) => {
      if (!isLinkElement(e.target)) {
        const touch = e.originalEvent.touches[0];
        startDrag(touch.pageX, $breadcrumb.scrollLeft());
      }
    })
    .on("touchmove", (e) => {
      const touch = e.originalEvent.touches[0];
      if (touch && handleMove(touch.pageX)) {
        e.preventDefault();
      }
    })
    .on("touchend", endDrag);

  // Scroll events
  $breadcrumb.on("scroll", () => {
    $breadcrumb.addClass("scrolling");
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      $breadcrumb.removeClass("scrolling");
    }, 150);
    updateBreadcrumbPosition();
  });

  // Prevent link clicks during drag
  $breadcrumb.on("click", "a", (e) => {
    if ($breadcrumb.hasClass("dragging")) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });
};

export const init = () => {
  $("body").addClass("has-breadcrumb");

  const initializeWhenReady = () => {
    if (document.readyState !== "complete") {
      setTimeout(initializeWhenReady, 100);
      return;
    }

    initDragScroll();
    updateBreadcrumbPosition();

    $(".breadcrumb-item").on("mouseenter touchend", updateBreadcrumbPosition);
    $(window).on("resize", updateBreadcrumbPosition);
  };

  initializeWhenReady();
};
